
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"84","height":"84","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M42 62.5c.992 0 1.823-.335 2.493-1.006.671-.67 1.007-1.502 1.007-2.493 0-.992-.336-1.823-1.007-2.494-.67-.671-1.502-1.006-2.493-1.006-.992 0-1.823.335-2.494 1.006-.67.67-1.006 1.502-1.006 2.494 0 .991.335 1.822 1.006 2.493.67.671 1.502 1.007 2.494 1.007zm-3.25-15.833h6.5v-26h-6.5v26zm3.257 36.5c-5.694 0-11.045-1.08-16.055-3.241s-9.368-5.094-13.074-8.798c-3.706-3.704-6.64-8.06-8.802-13.068C1.914 53.052.833 47.702.833 42.008c0-5.694 1.08-11.046 3.242-16.056 2.16-5.01 5.093-9.368 8.797-13.074 3.705-3.706 8.06-6.64 13.069-8.801C30.947 1.915 36.299.834 41.992.834c5.693 0 11.045 1.08 16.055 3.241s9.368 5.094 13.074 8.798c3.706 3.704 6.64 8.06 8.802 13.068 2.161 5.008 3.242 10.359 3.242 16.052 0 5.694-1.08 11.046-3.241 16.056-2.16 5.01-5.093 9.368-8.798 13.074-3.704 3.706-8.06 6.64-13.068 8.801-5.008 2.162-10.358 3.243-16.052 3.243zm-.007-6.5c9.678 0 17.875-3.358 24.591-10.075 6.717-6.716 10.076-14.914 10.076-24.591 0-9.678-3.359-17.875-10.076-24.592C59.875 10.692 51.678 7.334 42 7.334s-17.875 3.358-24.592 10.075C10.691 24.125 7.333 32.323 7.333 42c0 9.677 3.358 17.875 10.075 24.591C24.125 73.31 32.322 76.667 42 76.667z","fill":"#F8BB86"}})])
          )
        }
      }
    